import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselGroupsRequest = CommonTableRequest;

export interface VesselGroup {
    id: number;
    name: string | null;
    shortCode: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
    updatedAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface VesselGroupsResponse {
    data: VesselGroup[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateVesselGroupRequest {
    name: string;
    shortCode: string;
}

export type UpdateVesselGroupRequest = CreateVesselGroupRequest;

export const getApiVesselGroups = (
    clientId: number,
    tenantAlias: string,
    payload: VesselGroupsRequest,
): Promise<VesselGroupsResponse> =>
    httpApi
        .post<VesselGroupsResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-groups/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiVesselGroup = (
    clientId: number,
    tenantAlias: string,
    payload: CreateVesselGroupRequest,
): Promise<VesselGroup> =>
    httpApi
        .post<VesselGroup>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-groups`, payload)
        .then(({ data }) => data);

export const updateApiVesselGroup = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateVesselGroupRequest,
): Promise<VesselGroup> =>
    httpApi
        .put<VesselGroup>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-groups/${id}`, payload)
        .then(({ data }) => data);

export const deleteApiVesselGroup = (clientId: number, tenantAlias: string, id: number): Promise<VesselGroup> =>
    httpApi
        .delete<VesselGroup>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-groups/${id}`)
        .then(({ data }) => data);
